import React, { Component } from 'react'
import { translate } from 'react-i18next'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'

import { Roles } from '../../config'
import { fetchAppointments } from '../../actions'
import Loading from '../Loading'
import AppointmentsTable from './AppointmentsTable'
import AppointmentsCalendar from './AppointmentsCalendar'

import { Radio } from 'antd'
const RadioButton = Radio.Button
const RadioGroup = Radio.Group

class Appointments extends Component {
  state = {
    viewType: 'calendar'
  }

  componentDidMount = () => {
    const {
      role,
      match: { params },
      user,
      fetchAppointments
    } = this.props

    if (role === Roles.PROJECT.SALESPERSON) {
      // get current user's appointments (for salesperson)
      fetchAppointments(params.projectId, user.data.uid)
    } else {
      // get all appointments (for admins/agent)
      fetchAppointments(params.projectId)
    }
  }

  onViewTypeChange = e => {
    this.setState({
      viewType: e.target.value
    })
  }

  render () {
    const { loading, appointments } = this.props

    if (!appointments || loading.fetchAppointments) return <Loading />

    return (
      <div>
        <div style={{ marginBottom: 25, textAlign: 'center' }}>
          <RadioGroup onChange={this.onViewTypeChange} defaultValue={this.state.viewType}>
            <RadioButton value='table'>Table</RadioButton>
            <RadioButton value='calendar'>Calendar</RadioButton>
          </RadioGroup>
        </div>

        {this.state.viewType === 'table' && <AppointmentsTable />}
        {this.state.viewType === 'calendar' && <AppointmentsCalendar />}
      </div>
    )
  }
}

// =====================================
//  REDUX CONNECT
// -------------------------------------

const mapStateToProps = state => ({
  loading: state.loading,
  appointments: state.appointments,
  user: state.user
})

const mapDispatchToProps = {
  fetchAppointments
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(translate('translations')(Appointments)))



// WEBPACK FOOTER //
// ./src/components/Appointments/index.js